const Countries = [
  {
    id: 1,
    countryName: "Andorra",
    countryCode: "+376",
    code: "AD",
  },
  {
    id: 2,
    countryName: "United Arab Emirates",
    countryCode: "+971",
    code: "AE",
  },
  {
    id: 3,
    countryName: "Afghanistan",
    countryCode: "+93",
    code: "AF",
  },
  {
    id: 4,
    countryName: "Antigua and Barbuda",
    countryCode: "+1268",
    code: "AG",
  },
  {
    id: 5,
    countryName: "Anguilla",
    countryCode: "+1264",
    code: "AI",
  },
  {
    id: 6,
    countryName: "Albania",
    countryCode: "+355",
    code: "AL",
  },
  {
    id: 7,
    countryName: "Armenia",
    countryCode: "+374",
    code: "AM",
  },
  {
    id: 8,
    countryName: "Angola",
    countryCode: "+244",
    code: "AO",
  },
  {
    id: 9,
    countryName: "Antarctica",
    countryCode: "+672",
    code: "AQ",
  },
  {
    id: 10,
    countryName: "Argentina",
    countryCode: "+54",
    code: "AR",
  },
  {
    id: 11,
    countryName: "American Samoa",
    countryCode: "+1684",
    code: "AS",
  },
  {
    id: 12,
    countryName: "Austria",
    countryCode: "+43",
    code: "AT",
  },
  {
    id: 13,
    countryName: "Australia",
    countryCode: "+61",
    code: "AU",
  },
  {
    id: 14,
    countryName: "Aruba",
    countryCode: "+297",
    code: "AW",
  },
  {
    id: 15,
    countryName: "Alland Islands",
    countryCode: "+358",
    code: "AX",
  },
  {
    id: 16,
    countryName: "Azerbaijan",
    countryCode: "+994",
    code: "AZ",
  },
  {
    id: 17,
    countryName: "Bosnia and Herzegovina",
    countryCode: "+387",
    code: "BA",
  },
  {
    id: 18,
    countryName: "Barbados",
    countryCode: "+1246",
    code: "BB",
  },
  {
    id: 19,
    countryName: "Bangladesh",
    countryCode: "+880",
    code: "BD",
  },
  {
    id: 20,
    countryName: "Belgium",
    countryCode: "+32",
    code: "BE",
  },
  {
    id: 21,
    countryName: "Burkina Faso",
    countryCode: "+226",
    code: "BF",
  },
  {
    id: 22,
    countryName: "Bulgaria",
    countryCode: "+359",
    code: "BG",
  },
  {
    id: 23,
    countryName: "Bahrain",
    countryCode: "+973",
    code: "BH",
  },
  {
    id: 24,
    countryName: "Burundi",
    countryCode: "+257",
    code: "BI",
  },
  {
    id: 25,
    countryName: "Benin",
    countryCode: "+229",
    code: "BJ",
  },
  {
    id: 26,
    countryName: "Saint Barthelemy",
    countryCode: "+590",
    code: "BL",
  },
  {
    id: 27,
    countryName: "Bermuda",
    countryCode: "+1441",
    code: "BM",
  },
  {
    id: 28,
    countryName: "Brunei Darussalam",
    countryCode: "+673",
    code: "BN",
  },
  {
    id: 29,
    countryName: "Bolivia",
    countryCode: "+591",
    code: "BO",
  },
  {
    id: 30,
    countryName: "Brazil",
    countryCode: "+55",
    code: "BR",
  },
  {
    id: 31,
    countryName: "Bahamas",
    countryCode: "+1242",
    code: "BS",
  },
  {
    id: 32,
    countryName: "Bhutan",
    countryCode: "+975",
    code: "BT",
  },
  {
    id: 33,
    countryName: "Bouvet Island",
    countryCode: "+47",
    code: "BV",
  },
  {
    id: 34,
    countryName: "Botswana",
    countryCode: "+267",
    code: "BW",
  },
  {
    id: 35,
    countryName: "Belarus",
    countryCode: "+375",
    code: "BY",
  },
  {
    id: 36,
    countryName: "Belize",
    countryCode: "+501",
    code: "BZ",
  },
  {
    id: 37,
    countryName: "Canada",
    countryCode: "+1",
    code: "CA",
  },
  {
    id: 38,
    countryName: "Cocos (Keeling) Islands",
    countryCode: "+61",
    code: "CC",
  },
  {
    id: 39,
    countryName: "Congo, Democratic Republic of the",
    countryCode: "+243",
    code: "CD",
  },
  {
    id: 40,
    countryName: "Central African Republic",
    countryCode: "+236",
    code: "CF",
  },
  {
    id: 41,
    countryName: "Congo, Republic of the",
    countryCode: "+242",
    code: "CG",
  },
  {
    id: 42,
    countryName: "Switzerland",
    countryCode: "+41",
    code: "CH",
  },
  {
    id: 43,
    countryName: "Cote d'Ivoire",
    countryCode: "+225",
    code: "CI",
  },
  {
    id: 44,
    countryName: "Cook Islands",
    countryCode: "+682",
    code: "CK",
  },
  {
    id: 45,
    countryName: "Chile",
    countryCode: "+56",
    code: "CL",
  },
  {
    id: 46,
    countryName: "Cameroon",
    countryCode: "+237",
    code: "CM",
  },
  {
    id: 47,
    countryName: "China",
    countryCode: "+86",
    code: "CN",
  },
  {
    id: 48,
    countryName: "Colombia",
    countryCode: "+57",
    code: "CO",
  },
  {
    id: 49,
    countryName: "Costa Rica",
    countryCode: "+506",
    code: "CR",
  },
  {
    id: 50,
    countryName: "Cuba",
    countryCode: "+53",
    code: "CU",
  },
  {
    id: 51,
    countryName: "Cape Verde",
    countryCode: "+238",
    code: "CV",
  },
  {
    id: 52,
    countryName: "Curacao",
    countryCode: "+599",
    code: "CW",
  },
  {
    id: 53,
    countryName: "Christmas Island",
    countryCode: "+61",
    code: "CX",
  },
  {
    id: 54,
    countryName: "Cyprus",
    countryCode: "+357",
    code: "CY",
  },
  {
    id: 55,
    countryName: "Czech Republic",
    countryCode: "+420",
    code: "CZ",
  },
  {
    id: 56,
    countryName: "Germany",
    countryCode: "+49",
    code: "DE",
  },
  {
    id: 57,
    countryName: "Djibouti",
    countryCode: "+253",
    code: "DJ",
  },
  {
    id: 58,
    countryName: "Denmark",
    countryCode: "+45",
    code: "DK",
  },
  {
    id: 59,
    countryName: "Dominica",
    countryCode: "+1767",
    code: "DM",
  },
  {
    id: 60,
    countryName: "Dominican Republic",
    countryCode: "+1809",
    code: "DO",
  },
  {
    id: 61,
    countryName: "Algeria",
    countryCode: "+213",
    code: "DZ",
  },
  {
    id: 62,
    countryName: "Ecuador",
    countryCode: "+593",
    code: "EC",
  },
  {
    id: 63,
    countryName: "Estonia",
    countryCode: "+372",
    code: "EE",
  },
  {
    id: 64,
    countryName: "Egypt",
    countryCode: "+20",
    code: "EG",
  },
  {
    id: 65,
    countryName: "Western Sahara",
    countryCode: "+212",
    code: "EH",
  },
  {
    id: 66,
    countryName: "Eritrea",
    countryCode: "+291",
    code: "ER",
  },
  {
    id: 67,
    countryName: "Spain",
    countryCode: "+34",
    code: "ES",
  },
  {
    id: 68,
    countryName: "Ethiopia",
    countryCode: "+251",
    code: "ET",
  },
  {
    id: 69,
    countryName: "Finland",
    countryCode: "+358",
    code: "FI",
  },
  {
    id: 70,
    countryName: "Fiji",
    countryCode: "+679",
    code: "FJ",
  },
  {
    id: 71,
    countryName: "Falkland Islands (Malvinas)",
    countryCode: "+500",
    code: "FK",
  },
  {
    id: 72,
    countryName: "Micronesia, Federated States of",
    countryCode: "+691",
    code: "FM",
  },
  {
    id: 73,
    countryName: "Faroe Islands",
    countryCode: "+298",
    code: "FO",
  },
  {
    id: 74,
    countryName: "France",
    countryCode: "+33",
    code: "FR",
  },
  {
    id: 75,
    countryName: "Gabon",
    countryCode: "+241",
    code: "GA",
  },
  {
    id: 76,
    countryName: "United Kingdom",
    countryCode: "+44",
    code: "GB",
  },
  {
    id: 77,
    countryName: "Grenada",
    countryCode: "+1473",
    code: "GD",
  },
  {
    id: 78,
    countryName: "Georgia",
    countryCode: "+995",
    code: "GE",
  },
  {
    id: 79,
    countryName: "French Guiana",
    countryCode: "+594",
    code: "GF",
  },
  {
    id: 80,
    countryName: "Guernsey",
    countryCode: "+44",
    code: "GG",
  },
  {
    id: 81,
    countryName: "Ghana",
    countryCode: "+233",
    code: "GH",
  },
  {
    id: 82,
    countryName: "Gibraltar",
    countryCode: "+350",
    code: "GI",
  },
  {
    id: 83,
    countryName: "Greenland",
    countryCode: "+299",
    code: "GL",
  },
  {
    id: 84,
    countryName: "Gambia",
    countryCode: "+220",
    code: "GM",
  },
  {
    id: 85,
    countryName: "Guinea",
    countryCode: "+224",
    code: "GN",
  },
  {
    id: 86,
    countryName: "Guadeloupe",
    countryCode: "+590",
    code: "GP",
  },
  {
    id: 87,
    countryName: "Equatorial Guinea",
    countryCode: "+240",
    code: "GQ",
  },
  {
    id: 88,
    countryName: "Greece",
    countryCode: "+30",
    code: "GR",
  },
  {
    id: 89,
    countryName: "South Georgia and the South Sandwich Islands",
    countryCode: "+500",
    code: "GS",
  },
  {
    id: 90,
    countryName: "Guatemala",
    countryCode: "+502",
    code: "GT",
  },
  {
    id: 91,
    countryName: "Guam",
    countryCode: "+1671",
    code: "GU",
  },
  {
    id: 92,
    countryName: "Guinea-Bissau",
    countryCode: "+245",
    code: "GW",
  },
  {
    id: 93,
    countryName: "Guyana",
    countryCode: "+592",
    code: "GY",
  },
  {
    id: 94,
    countryName: "Hong Kong",
    countryCode: "+852",
    code: "HK",
  },
  {
    id: 95,
    countryName: "Heard Island and McDonald Islands",
    countryCode: "+672",
    code: "HM",
  },
  {
    id: 96,
    countryName: "Honduras",
    countryCode: "+504",
    code: "HN",
  },
  {
    id: 97,
    countryName: "Croatia",
    countryCode: "+385",
    code: "HR",
  },
  {
    id: 98,
    countryName: "Haiti",
    countryCode: "+509",
    code: "HT",
  },
  {
    id: 99,
    countryName: "Hungary",
    countryCode: "+36",
    code: "HU",
  },
  {
    id: 100,
    countryName: "Indonesia",
    countryCode: "+62",
    code: "ID",
  },
  {
    id: 101,
    countryName: "Ireland",
    countryCode: "+353",
    code: "IE",
  },
  {
    id: 102,
    countryName: "Israel",
    countryCode: "+972",
    code: "IL",
  },
  {
    id: 103,
    countryName: "Isle of Man",
    countryCode: "+44",
    code: "IM",
  },
  {
    id: 104,
    countryName: "India",
    countryCode: "+91",
    code: "IN",
  },
  {
    id: 105,
    countryName: "British Indian Ocean Territory",
    countryCode: "+246",
    code: "IO",
  },
  {
    id: 106,
    countryName: "Iraq",
    countryCode: "+964",
    code: "IQ",
  },
  {
    id: 107,
    countryName: "Iran, Islamic Republic of",
    countryCode: "+98",
    code: "IR",
  },
  {
    id: 108,
    countryName: "Iceland",
    countryCode: "+354",
    code: "IS",
  },
  {
    id: 109,
    countryName: "Italy",
    countryCode: "+39",
    code: "IT",
  },
  {
    id: 110,
    countryName: "Jersey",
    countryCode: "+44",
    code: "JE",
  },
  {
    id: 111,
    countryName: "Jamaica",
    countryCode: "+1876",
    code: "JM",
  },
  {
    id: 112,
    countryName: "Jordan",
    countryCode: "+962",
    code: "JO",
  },
  {
    id: 113,
    countryName: "Japan",
    countryCode: "+81",
    code: "JP",
  },
  {
    id: 114,
    countryName: "Kenya",
    countryCode: "+254",
    code: "KE",
  },
  {
    id: 115,
    countryName: "Kyrgyzstan",
    countryCode: "+996",
    code: "KG",
  },
  {
    id: 116,
    countryName: "Cambodia",
    countryCode: "+855",
    code: "KH",
  },
  {
    id: 117,
    countryName: "Kiribati",
    countryCode: "+686",
    code: "KI",
  },
  {
    id: 118,
    countryName: "Comoros",
    countryCode: "+269",
    code: "KM",
  },
  {
    id: 119,
    countryName: "Saint Kitts and Nevis",
    countryCode: "+1869",
    code: "KN",
  },
  {
    id: 120,
    countryName: "Korea, Democratic People's Republic of",
    countryCode: "+850",
    code: "KP",
  },
  {
    id: 121,
    countryName: "Korea, Republic of",
    countryCode: "+82",
    code: "KR",
  },
  {
    id: 122,
    countryName: "Kuwait",
    countryCode: "+965",
    code: "KW",
  },
  {
    id: 123,
    countryName: "Cayman Islands",
    countryCode: "+1345",
    code: "KY",
  },
  {
    id: 124,
    countryName: "Kazakhstan",
    countryCode: "+7",
    code: "KZ",
  },
  {
    id: 125,
    countryName: "Lao People's Democratic Republic",
    countryCode: "+856",
    code: "LA",
  },
  {
    id: 126,
    countryName: "Lebanon",
    countryCode: "+961",
    code: "LB",
  },
  {
    id: 127,
    countryName: "Saint Lucia",
    countryCode: "+1758",
    code: "LC",
  },
  {
    id: 128,
    countryName: "Liechtenstein",
    countryCode: "+423",
    code: "LI",
  },
  {
    id: 129,
    countryName: "Sri Lanka",
    countryCode: "+94",
    code: "LK",
  },
  {
    id: 130,
    countryName: "Liberia",
    countryCode: "+231",
    code: "LR",
  },
  {
    id: 131,
    countryName: "Lesotho",
    countryCode: "+266",
    code: "LS",
  },
  {
    id: 132,
    countryName: "Lithuania",
    countryCode: "+370",
    code: "LT",
  },
  {
    id: 133,
    countryName: "Luxembourg",
    countryCode: "+352",
    code: "LU",
  },
  {
    id: 134,
    countryName: "Latvia",
    countryCode: "+371",
    code: "LV",
  },
  {
    id: 135,
    countryName: "Libya",
    countryCode: "+218",
    code: "LY",
  },
  {
    id: 136,
    countryName: "Morocco",
    countryCode: "+212",
    code: "MA",
  },
  {
    id: 137,
    countryName: "Monaco",
    countryCode: "+377",
    code: "MC",
  },
  {
    id: 138,
    countryName: "Moldova, Republic of",
    countryCode: "+373",
    code: "MD",
  },
  {
    id: 139,
    countryName: "Montenegro",
    countryCode: "+382",
    code: "ME",
  },
  {
    id: 140,
    countryName: "Saint Martin (French part)",
    countryCode: "+590",
    code: "MF",
  },
  {
    id: 141,
    countryName: "Madagascar",
    countryCode: "+261",
    code: "MG",
  },
  {
    id: 142,
    countryName: "Marshall Islands",
    countryCode: "+692",
    code: "MH",
  },
  {
    id: 143,
    countryName: "Macedonia, the Former Yugoslav Republic of",
    countryCode: "+389",
    code: "MK",
  },
  {
    id: 144,
    countryName: "Mali",
    countryCode: "+223",
    code: "ML",
  },
  {
    id: 145,
    countryName: "Myanmar",
    countryCode: "+95",
    code: "MM",
  },
  {
    id: 146,
    countryName: "Mongolia",
    countryCode: "+976",
    code: "MN",
  },
  {
    id: 147,
    countryName: "Macao",
    countryCode: "+853",
    code: "MO",
  },
  {
    id: 148,
    countryName: "Northern Mariana Islands",
    countryCode: "+1670",
    code: "MP",
  },
  {
    id: 149,
    countryName: "Martinique",
    countryCode: "+596",
    code: "MQ",
  },
  {
    id: 150,
    countryName: "Mauritania",
    countryCode: "+222",
    code: "MR",
  },
  {
    id: 151,
    countryName: "Montserrat",
    countryCode: "+1664",
    code: "MS",
  },
  {
    id: 152,
    countryName: "Malta",
    countryCode: "+356",
    code: "MT",
  },
  {
    id: 153,
    countryName: "Mauritius",
    countryCode: "+230",
    code: "MU",
  },
  {
    id: 154,
    countryName: "Maldives",
    countryCode: "+960",
    code: "MV",
  },
  {
    id: 155,
    countryName: "Malawi",
    countryCode: "+265",
    code: "MW",
  },
  {
    id: 156,
    countryName: "Mexico",
    countryCode: "+52",
    code: "MX",
  },
  {
    id: 157,
    countryName: "Malaysia",
    countryCode: "+60",
    code: "MY",
  },
  {
    id: 158,
    countryName: "Mozambique",
    countryCode: "+258",
    code: "MZ",
  },
  {
    id: 159,
    countryName: "Namibia",
    countryCode: "+264",
    code: "NA",
  },
  {
    id: 160,
    countryName: "New Caledonia",
    countryCode: "+687",
    code: "NC",
  },
  {
    id: 161,
    countryName: "Niger",
    countryCode: "+227",
    code: "NE",
  },
  {
    id: 162,
    countryName: "Norfolk Island",
    countryCode: "+672",
    code: "NF",
  },
  {
    id: 163,
    countryName: "Nigeria",
    countryCode: "+234",
    code: "NG",
  },
  {
    id: 164,
    countryName: "Nicaragua",
    countryCode: "+505",
    code: "NI",
  },
  {
    id: 165,
    countryName: "Netherlands",
    countryCode: "+31",
    code: "NL",
  },
  {
    id: 166,
    countryName: "Norway",
    countryCode: "+47",
    code: "NO",
  },
  {
    id: 167,
    countryName: "Nepal",
    countryCode: "+977",
    code: "NP",
  },
  {
    id: 168,
    countryName: "Nauru",
    countryCode: "+674",
    code: "NR",
  },
  {
    id: 169,
    countryName: "Niue",
    countryCode: "+683",
    code: "NU",
  },
  {
    id: 170,
    countryName: "New Zealand",
    countryCode: "+64",
    code: "NZ",
  },
  {
    id: 171,
    countryName: "Oman",
    countryCode: "+968",
    code: "OM",
  },
  {
    id: 172,
    countryName: "Panama",
    countryCode: "+507",
    code: "PA",
  },
  {
    id: 173,
    countryName: "Peru",
    countryCode: "+51",
    code: "PE",
  },
  {
    id: 174,
    countryName: "French Polynesia",
    countryCode: "+689",
    code: "PF",
  },
  {
    id: 175,
    countryName: "Papua New Guinea",
    countryCode: "+675",
    code: "PG",
  },
  {
    id: 176,
    countryName: "Philippines",
    countryCode: "+63",
    code: "PH",
  },
  {
    id: 177,
    countryName: "Pakistan",
    countryCode: "+92",
    code: "PK",
  },
  {
    id: 178,
    countryName: "Poland",
    countryCode: "+48",
    code: "PL",
  },
  {
    id: 179,
    countryName: "Saint Pierre and Miquelon",
    countryCode: "+508",
    code: "PM",
  },
  {
    id: 180,
    countryName: "Pitcairn",
    countryCode: "+870",
    code: "PN",
  },
  {
    id: 181,
    countryName: "Puerto Rico",
    countryCode: "+1",
    code: "PR",
  },
  {
    id: 182,
    countryName: "Palestine, State of",
    countryCode: "+970",
    code: "PS",
  },
  {
    id: 183,
    countryName: "Portugal",
    countryCode: "+351",
    code: "PT",
  },
  {
    id: 184,
    countryName: "Palau",
    countryCode: "+680",
    code: "PW",
  },
  {
    id: 185,
    countryName: "Paraguay",
    countryCode: "+595",
    code: "PY",
  },
  {
    id: 186,
    countryName: "Qatar",
    countryCode: "+974",
    code: "QA",
  },
  {
    id: 187,
    countryName: "Reunion",
    countryCode: "+262",
    code: "RE",
  },
  {
    id: 188,
    countryName: "Romania",
    countryCode: "+40",
    code: "RO",
  },
  {
    id: 189,
    countryName: "Serbia",
    countryCode: "+381",
    code: "RS",
  },
  {
    id: 190,
    countryName: "Russian Federation",
    countryCode: "+7",
    code: "RU",
  },
  {
    id: 191,
    countryName: "Rwanda",
    countryCode: "+250",
    code: "RW",
  },
  {
    id: 192,
    countryName: "Saudi Arabia",
    countryCode: "+966",
    code: "SA",
  },
  {
    id: 193,
    countryName: "Solomon Islands",
    countryCode: "+677",
    code: "SB",
  },
  {
    id: 194,
    countryName: "Seychelles",
    countryCode: "+248",
    code: "SC",
  },
  {
    id: 195,
    countryName: "Sudan",
    countryCode: "+249",
    code: "SD",
  },
  {
    id: 196,
    countryName: "Sweden",
    countryCode: "+46",
    code: "SE",
  },
  {
    id: 197,
    countryName: "Singapore",
    countryCode: "+65",
    code: "SG",
  },
  {
    id: 198,
    countryName: "Saint Helena",
    countryCode: "+290",
    code: "SH",
  },
  {
    id: 199,
    countryName: "Slovenia",
    countryCode: "+386",
    code: "SI",
  },
  {
    id: 200,
    countryName: "Svalbard and Jan Mayen",
    countryCode: "+47",
    code: "SJ",
  },
  {
    id: 201,
    countryName: "Slovakia",
    countryCode: "+421",
    code: "SK",
  },
  {
    id: 202,
    countryName: "Sierra Leone",
    countryCode: "+232",
    code: "SL",
  },
  {
    id: 203,
    countryName: "San Marino",
    countryCode: "+378",
    code: "SM",
  },
  {
    id: 204,
    countryName: "Senegal",
    countryCode: "+221",
    code: "SN",
  },
  {
    id: 205,
    countryName: "Somalia",
    countryCode: "+252",
    code: "SO",
  },
  {
    id: 206,
    countryName: "Suriname",
    countryCode: "+597",
    code: "SR",
  },
  {
    id: 207,
    countryName: "South Sudan",
    countryCode: "+211",
    code: "SS",
  },
  {
    id: 208,
    countryName: "Sao Tome and Principe",
    countryCode: "+239",
    code: "ST",
  },
  {
    id: 209,
    countryName: "El Salvador",
    countryCode: "+503",
    code: "SV",
  },
  {
    id: 210,
    countryName: "Sint Maarten (Dutch part)",
    countryCode: "+1721",
    code: "SX",
  },
  {
    id: 211,
    countryName: "Syrian Arab Republic",
    countryCode: "+963",
    code: "SY",
  },
  {
    id: 212,
    countryName: "Swaziland",
    countryCode: "+268",
    code: "SZ",
  },
  {
    id: 213,
    countryName: "Turks and Caicos Islands",
    countryCode: "+1649",
    code: "TC",
  },
  {
    id: 214,
    countryName: "Chad",
    countryCode: "+235",
    code: "TD",
  },
  {
    id: 215,
    countryName: "French Southern Territories",
    countryCode: "+262",
    code: "TF",
  },
  {
    id: 216,
    countryName: "Togo",
    countryCode: "+228",
    code: "TG",
  },
  {
    id: 217,
    countryName: "Thailand",
    countryCode: "+66",
    code: "TH",
  },
  {
    id: 218,
    countryName: "Tajikistan",
    countryCode: "+992",
    code: "TJ",
  },
  {
    id: 219,
    countryName: "Tokelau",
    countryCode: "+690",
    code: "TK",
  },
  {
    id: 220,
    countryName: "Timor-Leste",
    countryCode: "+670",
    code: "TL",
  },
  {
    id: 221,
    countryName: "Turkmenistan",
    countryCode: "+993",
    code: "TM",
  },
  {
    id: 222,
    countryName: "Tunisia",
    countryCode: "+216",
    code: "TN",
  },
  {
    id: 223,
    countryName: "Tonga",
    countryCode: "+676",
    code: "TO",
  },
  {
    id: 224,
    countryName: "Turkey",
    countryCode: "+90",
    code: "TR",
  },
  {
    id: 225,
    countryName: "Trinidad and Tobago",
    countryCode: "+1868",
    code: "TT",
  },
  {
    id: 226,
    countryName: "Tuvalu",
    countryCode: "+688",
    code: "TV",
  },
  {
    id: 227,
    countryName: "Taiwan",
    countryCode: "+886",
    code: "TW",
  },
  {
    id: 228,
    countryName: "United Republic of Tanzania",
    countryCode: "+255",
    code: "TZ",
  },
  {
    id: 229,
    countryName: "Ukraine",
    countryCode: "+380",
    code: "UA",
  },
  {
    id: 230,
    countryName: "Uganda",
    countryCode: "+256",
    code: "UG",
  },
  {
    id: 231,
    countryName: "United States",
    countryCode: "+1",
    code: "US",
  },
  {
    id: 232,
    countryName: "Uruguay",
    countryCode: "+598",
    code: "UY",
  },
  {
    id: 233,
    countryName: "Uzbekistan",
    countryCode: "+998",
    code: "UZ",
  },
  {
    id: 234,
    countryName: "Holy See (Vatican City State)",
    countryCode: "+379",
    code: "VA",
  },
  {
    id: 235,
    countryName: "Saint Vincent and the Grenadines",
    countryCode: "+1784",
    code: "VC",
  },
  {
    id: 236,
    countryName: "Venezuela",
    countryCode: "+58",
    code: "VE",
  },
  {
    id: 237,
    countryName: "British Virgin Islands",
    countryCode: "+1284",
    code: "VG",
  },
  {
    id: 238,
    countryName: "US Virgin Islands",
    countryCode: "+1340",
    code: "VI",
  },
  {
    id: 239,
    countryName: "Vietnam",
    countryCode: "+84",
    code: "VN",
  },
  {
    id: 240,
    countryName: "Vanuatu",
    countryCode: "+678",
    code: "VU",
  },
  {
    id: 241,
    countryName: "Wallis and Futuna",
    countryCode: "+681",
    code: "WF",
  },
  {
    id: 242,
    countryName: "Samoa",
    countryCode: "+685",
    code: "WS",
  },
  {
    id: 243,
    countryName: "Kosovo",
    countryCode: "+383",
    code: "XK",
  },
  {
    id: 244,
    countryName: "Yemen",
    countryCode: "+967",
    code: "YE",
  },
  {
    id: 245,
    countryName: "Mayotte",
    countryCode: "+262",
    code: "YT",
  },
  {
    id: 246,
    countryName: "South Africa",
    countryCode: "+27",
    code: "ZA",
  },
  {
    id: 247,
    countryName: "Zambia",
    countryCode: "+260",
    code: "ZM",
  },
  {
    id: 248,
    countryName: "Zimbabwe",
    countryCode: "+263",
    code: "ZW",
  },
];

export default Countries;
